const { dataLayerListener } = require('./data-layer.cjs');
const { gtm, getGTMId, gtmNoScript } = require('./gtm.cjs');
const { platformIdReady } = require('./platform-id-ready.cjs');
const { ytm, ytmNoScript, ytmCookie, ytmSendUserParams, ytmSendEvent } = require('./ytm.cjs');
const { alfaPartners } = require('./partners.cjs');

const getCounters = (url, data) => {
    const { CUSTOM_YTM_ID, ENABLE_COUNTERS } = process.env;
    const {
        collectorData: { host }
    } = data;
    const gtmId = getGTMId(host);
    const isCountersEnabled = ENABLE_COUNTERS === 'true';
    const enableYtm = isCountersEnabled && CUSTOM_YTM_ID;
    const ytmScripts = [ytmNoScript, ytmCookie, dataLayerListener, ytmSendUserParams, ytmSendEvent];
    const headGTM = isCountersEnabled ? gtm(gtmId) : '';
    const headYTM = enableYtm ? ytm(url) : '';
    const bodyYTM = enableYtm ? ytmScripts.join('') : '';

    return {
        headCounters: [platformIdReady, headGTM, headYTM],
        bodyCounters: [gtmNoScript(gtmId), bodyYTM, isCountersEnabled ? alfaPartners(url) : ''],
        endBodyCounters: []
    };
};

module.exports = { getCounters };
